import { Component } from 'react'
import { enqueueSnackbar } from 'notistack'
class ToastComponent extends Component {
  constructor(props) {
    super(props)

    this.showToast = this.showToast.bind(this)
  }

  showToast(event) {
    const { message, type = 'success', ...snackbarProps } = event

    enqueueSnackbar(message, { variant: type, ...snackbarProps })
  }

  render() {
    return null
  }
}

export const Toast = ToastComponent
